var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAiMarket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 78,
    viewBox: "0 0 75 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73.7058 27.6328C77.4347 41.0425 73.1321 54.9543 61.1566 65.2805C49.181 75.6785 29.5324 82.4909 16.2661 74.316C2.99972 66.2128 -3.88444 42.9787 2.28262 26.1986C8.44968 9.34671 27.668 -1.12295 43.0139 0.0961229C58.4316 1.31519 70.0486 14.2947 73.7058 27.6328Z",
    fill: "#011E1E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3344_3028)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.3794 28.7739H48.3859V57.6557H43.3794V52.6854C40.8878 56.4993 37.2552 58.4092 32.4991 58.4092C28.4706 58.4092 25.0301 56.9315 22.1892 53.9878C19.3483 51.0442 17.9279 47.4522 17.9279 43.2178C17.9279 38.9833 19.3483 35.3914 22.1892 32.4418C25.0301 29.4982 28.4706 28.0205 32.4991 28.0205C37.2552 28.0205 40.8878 29.9304 43.3794 33.7443V28.7739ZM33.1336 53.5615C36.0502 53.5615 38.4894 52.5686 40.4454 50.5828C42.4014 48.597 43.3794 46.1439 43.3794 43.2178C43.3794 40.2916 42.4014 37.8327 40.4454 35.8528C38.4894 33.867 36.0443 32.8741 33.1336 32.8741C30.2229 32.8741 27.836 33.867 25.88 35.8528C23.924 37.8386 22.9402 40.2975 22.9402 43.2178C22.9402 46.1381 23.9182 48.6028 25.88 50.5828C27.836 52.5686 30.2578 53.5615 33.1336 53.5615Z",
    fill: "#B8EF36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.7243 26.2273C52.7637 26.2273 51.9603 25.9002 51.3083 25.2461C50.6505 24.5919 50.3303 23.8035 50.3303 22.8806C50.3303 21.9578 50.6563 21.1577 51.3083 20.4802C51.9603 19.8085 52.7637 19.4697 53.7243 19.4697C54.6848 19.4697 55.43 19.8085 56.082 20.4802C56.7398 21.1577 57.06 21.952 57.06 22.8806C57.06 23.8093 56.734 24.5919 56.082 25.2461C55.43 25.9061 54.6441 26.2273 53.7243 26.2273Z",
    fill: "#B8EF36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.1984 28.7734H51.1919V57.6552H56.1984V28.7734Z",
    fill: "#B8EF36"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3344_3028"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39.1321,
    height: 38.9393,
    fill: "white",
    transform: "translate(17.9279 19.4697)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiMarket);
export default __webpack_public_path__ + "static/media/ai_market.23e25c5bac0536cb26e206d257a343fb.svg";
export { ForwardRef as ReactComponent };